import { Component, OnInit } from '@angular/core';

import { ApiService } from '../shared/api-service/api.service';
import { AuthService } from '../shared/auth/auth.service';
import { Logging } from '../logging';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

declare var jquery:any;
declare var $ :any;
declare var App:any;


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  constructor(
    private api: ApiService,
    private auth: AuthService,
    private router: Router
    ) {


   }

  loading: Boolean = false;
  hasError: Boolean = false;
  errorMessage: string ;
  userDetails: any ;
  showForceLogoutError:any = false;
  staffDetails: any;



  ngOnInit() {


    this.auth.forcelogout.subscribe((value) => {
      this.showForceLogoutError = value;

    });

    if(this.auth.isLoggedIn()){
      this.router.navigate(['/dashboard']);
    }



    this.auth.removeLoginDetails();


    //Navigate to dashboard after login success with this observable
    this.auth.token_set.subscribe((status) => {
      if(status == true){
        this.router.navigate(['/dashboard']);
      }
    });


  }

  verifyEmail(form: NgForm){

    var self = this;

    //Set loading to true to show loader
    this.loading = true;
    this.hasError = false;

    // Collect form values
    const values = form.value;

    const body = {
      email: values.email,
    };

    //Make the api request
    this.api.post('/users/validationstatus', body)
      .subscribe(
        res_data => {
        Logging.log(res_data);

        this.userDetails = res_data.data[0];
        this.userDetails.email = values.email;
        var user_info = res_data.data[0];


        //Set the login details for the current user.
        this.auth.setLoginDetails(this.userDetails);
        Logging.log(this.auth.getLoginDetails());

        // Set the login details for staff
        // this.auth.setStaffLoginDetails(this.staffDetails)
        var animationOut = "animated fadeOutLeft";
        var animationend = "wenkitAnimationEnd mozAnimationEnd MS AnimationEnd oanimationend animationend";

        //Show The next form depending on user data
        $('#email-verification')
          .addClass(animationOut)
          .one(animationend, function(){

            //Redirect if condition is met
            if(user_info.emailvalidated == false || user_info.phonevalidated == false){
              self.router.navigate(['/login/validate-credentials']);
              return true;

            }else if(user_info.accountlocked == true &&
                user_info.emailvalidated == true &&
                user_info.phonevalidated == true){

              self.router.navigate(['/login/account-locked']);
              return true;

            }else if(user_info.emailvalidated == true || user_info.phonevalidated == true){
              self.router.navigate(['/login/verify-password']);
              return true;
            }



          });

          this.loading = false;

        }, error_message => {
          this.loading = false;
          this.hasError = true;
          this.errorMessage = error_message;
        }
      );



  }




  verifyPassword(form: NgForm){
    // Collect form values
    const values = form.value;

    Logging.log(values.password);
  }



  onSubmit(form: NgForm){

    //Set loading to true to show loader
    this.loading = true;
    this.hasError = false;

    // Collect form values
    const values = form.value;

    const body = {
      username: values.email,
      password: values.password
    };



    //   // Make api request to staff Login endpoint

    //Make the api request
    this.api.post('authentication/login', body)
      .subscribe(
        res_data => {
        Logging.log(res_data.data[0].accessToken.token);

        //Set the token for the current user.
        const userToken: string = res_data.data[0].accessToken.token;
        this.auth.setToken(userToken);


        //Fetch the user customer details
        this.api.get('customers/'+ res_data.data[0].useraccount.userid)
        .subscribe(
          res_data1 => {
          Logging.log(res_data1);

          res_data.data[0].useraccount['customer'] = res_data1.data[0];

          //Set the user into the local storage to prevent loss after hard rest
          this.auth.setUser(res_data.data[0].useraccount);

          }, error_message => {
            this.loading = false;
          //  this.hasError = true;
          //  this.errorMessage = error_message;
          }
        );

        }, error_message => {
          this.loading = false;
          this.hasError = true;
          this.errorMessage = error_message;
        }
      );




  }


  clearErrors(){
    this.hasError = false;
  }



}



// WEBPACK FOOTER //
// ./src/app/login/login.component.ts